import { BaseFilter, WorkdayDatasetDto, PaginatedQuery, SortDirections, SorterDescriptor } from "app/ApiClient";
import { LoadingState } from "types";

export interface PaginatedDtoOfWorkdayProjectGroupedDataset {
  pageData?: WorkdayProjectGroupedDataset[] | undefined;
  totalCount?: number;
  pageNumber?: number;
  pageSize?: number;
}

export interface WorkdayProjectGroupedDataset {
  parentDataset: WorkdayProjectDataset;
  childDatasets: WorkdayProjectDataset[];
}

export interface WorkdayProjectDataset extends WorkdayDatasetDto {
  dataFormat?: string;
  normalizedOriginProjectId?: string;
}

export interface PageContextOfWorkdayProjectDatasetFilter {
  page?: PaginatedQuery | undefined;
  filter?: WorkdayProjectDatasetFilter | undefined;
  sortList?: SorterDescriptor[] | undefined;
}

export interface WorkdayProjectDatasetFilter extends BaseFilter {
  searchString?: string | undefined;
}

export interface WorkdayProjectGroupedDatasetData extends PaginatedDtoOfWorkdayProjectGroupedDataset {
  allData: WorkdayProjectDataset[];
  groupedData: WorkdayProjectGroupedDataset[];
  pageData: WorkdayProjectGroupedDataset[];
}

export interface WorkdayProjectDatasetsState {
  datasetsLoading: LoadingState;
  error?: string;
  pageContext: PageContextOfWorkdayProjectDatasetFilter;
  filters?: { [key in keyof WorkdayProjectDataset]: string[] };
  workdayProjectGroupedDatasets: WorkdayProjectGroupedDatasetData;
}

export const initialWorkdayProjectDatasetsState: WorkdayProjectDatasetsState = {
  datasetsLoading: LoadingState.idle,
  pageContext: {
    page: { pageNumber: 1, pageSize: 10 },
    sortList: [{ directions: SortDirections.Desceding, field: "versionDate" }],
    filter: {},
  },
  workdayProjectGroupedDatasets: {
    allData: [],
    groupedData: [],
    pageData: [],
  },
};
